import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { companyInfo } from '../data/mock';

const Header = ({ onGetQuote }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'About', href: '#about' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'SME Plans', href: '/sme-plans', isRoute: true },
    { label: 'AI Surveillance', href: '/surveillance', isRoute: true },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleNavClick = (link) => {
    if (link.isRoute) {
      navigate(link.href);
      setMobileMenuOpen(false);
    } else {
      scrollToSection(link.href);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
            <div className="flex items-center gap-3">
              <img 
                src={companyInfo.logo}
                alt="Tech360 Technologies"
                className="h-14 w-auto object-contain"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNavClick(link)}
                className="text-gray-700 hover:text-emerald-600 font-medium transition-colors"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <Button 
              onClick={() => navigate('/customer/login')}
              variant="outline"
              className="border-emerald-500 text-emerald-600 hover:bg-emerald-50 px-4 py-2 rounded-lg transition-all duration-300"
            >
              <LogIn className="w-4 h-4 mr-2" />
              Customer Login
            </Button>
            <Button 
              onClick={() => navigate('/admin/login')}
              variant="outline"
              className="border-emerald-500 text-emerald-600 hover:bg-emerald-50 px-4 py-2 rounded-lg transition-all duration-300"
            >
              <LogIn className="w-4 h-4 mr-2" />
              Admin Login
            </Button>
            <Button 
              onClick={onGetQuote}
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-2 rounded-lg shadow-md shadow-emerald-500/30 transition-all duration-300 hover:shadow-emerald-500/50"
            >
              Get Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-900" />
            ) : (
              <Menu className="w-6 h-6 text-gray-900" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => handleNavClick(link)}
                  className="text-left text-gray-700 hover:text-emerald-600 font-medium py-2 transition-colors"
                >
                  {link.label}
                </button>
              ))}
              <Button 
                onClick={() => {
                  navigate('/customer/login');
                  setMobileMenuOpen(false);
                }}
                variant="outline"
                className="border-emerald-500 text-emerald-600 hover:bg-emerald-50 w-full mt-2"
              >
                <LogIn className="w-4 h-4 mr-2" />
                Customer Login
              </Button>
              <Button 
                onClick={() => {
                  navigate('/admin/login');
                  setMobileMenuOpen(false);
                }}
                variant="outline"
                className="border-emerald-500 text-emerald-600 hover:bg-emerald-50 w-full mt-2"
              >
                <LogIn className="w-4 h-4 mr-2" />
                Admin Login
              </Button>
              <Button 
                onClick={() => {
                  onGetQuote();
                  setMobileMenuOpen(false);
                }}
                className="bg-emerald-500 hover:bg-emerald-600 text-white w-full"
              >
                Get Quote
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
